export function getOptionsUrl() {
  return 'https://pancakeswap.stryke.xyz'
}
